
















import { Component, Vue } from "vue-property-decorator";
import Viewer from "v-viewer";
import "viewerjs/dist/viewer.css";
import { imgList } from "@/components/listData";
Vue.use(Viewer);

Viewer.setDefaults({
  // 启用inline模式
  inline: false,
  // 右上角箭头
  button: true,
  // 缩略图
  navbar: false,
  // 显示当前图片的标题
  title: true,
  // 显示工具栏
  toolbar: true,
  // 显示缩放百分比
  tooltip: true,
  // 图片是否可移动
  movable: true,
  // 图片是否可缩放
  zoomable: true,
  // 图片是否可旋转
  rotatable: false,
  // 播放时是否全屏
  fullscreen: false,
  // 是否支持键盘
  keyboard: true,
});
@Component({
  components: {},
})
export default class Home extends Vue {
  public imgList: any = imgList;
}
